import React from "react";

type FormsIconProps = {
  className?: string;
  color?: string;
  onClick?: () => void;
  size?: number;
};

const FormsIcon = ({ size = 20, color = 'white', className, onClick }: FormsIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M16.6667 6.87484V14.9998C16.6667 17.4998 15.175 18.3332 13.3334 18.3332H6.66671C4.82504 18.3332 3.33337 17.4998 3.33337 14.9998V6.87484C3.33337 4.1665 4.82504 3.5415 6.66671 3.5415C6.66671 4.05817 6.87502 4.52483 7.21668 4.8665C7.55835 5.20817 8.02504 5.4165 8.54171 5.4165H11.4584C12.4917 5.4165 13.3334 4.57484 13.3334 3.5415C15.175 3.5415 16.6667 4.1665 16.6667 6.87484Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 3.5415C13.3333 4.57484 12.4916 5.4165 11.4583 5.4165H8.54163C8.02496 5.4165 7.55827 5.20817 7.2166 4.8665C6.87494 4.52483 6.66663 4.05817 6.66663 3.5415C6.66663 2.50817 7.50829 1.6665 8.54163 1.6665H11.4583C11.975 1.6665 12.4416 1.87484 12.7833 2.21651C13.125 2.55817 13.3333 3.02484 13.3333 3.5415Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66663 10.8335H9.99996"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66663 14.1665H13.3333"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FormsIcon;
